import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { BaasEdgePoolError } from '../../sections/types/BaasEdgePoolError';
import { Cluster } from '../../sections/types/Cluster';

export interface IGetBaasClusterDetailsParams {
  clusterIds: readonly string[];
}

export interface IGetBaasClusterDetailsResult extends IResult {
  success?: Record<string, Cluster>;
  error?: BaasEdgePoolError;
}

export class GetBaasClusterDetailsRequest extends Request<IGetBaasClusterDetailsParams, IGetBaasClusterDetailsResult> {
  constructor(params: IGetBaasClusterDetailsParams) {
    super('getBaasClusterDetails', params);
  }
}
